/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NzbnCompanyResponseBaseResponse as ModelsCustomerNzbnCompanyResponseBaseResponse } from '../../models/Models/Customer/nzbn-company-response-base-response';

export interface V4PublicApplicationApplicationIdGetCompanyAutocompleteGet$Xml$Params {

/**
 * The query string eg. "220 Queen Auc"
 */
  query?: string;
  applicationId: string;
}

export function v4PublicApplicationApplicationIdGetCompanyAutocompleteGet$Xml(http: HttpClient, rootUrl: string, params: V4PublicApplicationApplicationIdGetCompanyAutocompleteGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerNzbnCompanyResponseBaseResponse>> {
  const rb = new RequestBuilder(rootUrl, v4PublicApplicationApplicationIdGetCompanyAutocompleteGet$Xml.PATH, 'get');
  if (params) {
    rb.query('query', params.query, {});
    rb.path('applicationId', params.applicationId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/xml', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsCustomerNzbnCompanyResponseBaseResponse>;
    })
  );
}

v4PublicApplicationApplicationIdGetCompanyAutocompleteGet$Xml.PATH = '/v4/public/application/{applicationId}/getCompanyAutocomplete';
